import { combineReducers } from '@reduxjs/toolkit';
import login from '../login/redux/LoginRedux';
import chat from '../chat/redux/ChatRedux';
import websocket from '../websocket/redux/WebsocketRedux';
import userDetail from '../userlist/redux/UserDetailRedux';
const rootReducer = combineReducers({
  login,
  chat,
  websocket,
  userDetail,
  // 다른 리듀서를 추가하세요
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
